const items = document.querySelectorAll('.recruitment-sec__item');
const nextButtons = document.querySelectorAll('.accordion-item__button:not(.left)');
const prevButtons = document.querySelectorAll('.accordion-item__button.left');

let currentIndex = 0;

function updateButtonStates() {
  prevButtons.forEach((btn) => btn.classList.toggle('disabled', currentIndex === 0));
  nextButtons.forEach((btn) => btn.classList.toggle('disabled', currentIndex === items.length - 1));
}

function activateItem(index) {
  if (index < 0 || index >= items.length) return;

  currentIndex = index;

  items.forEach((item, i) => {
    item.classList.toggle('active', i === index);
  });

  updateButtonStates();
}

nextButtons.forEach((button) => {
  button.addEventListener('click', (event) => {
    event.stopPropagation();
    if (currentIndex < items.length - 1) {
      activateItem(currentIndex + 1);
    }
  });
});

prevButtons.forEach((button) => {
  button.addEventListener('click', (event) => {
    event.stopPropagation();
    if (currentIndex > 0) {
      activateItem(currentIndex - 1);
    }
  });
});

items.forEach((item, index) => {
  item.addEventListener('click', () => {
    activateItem(index);
  });
});

activateItem(0);
